/**
 * 从 API 响应中提取选项列表数组。
 * 与 AndSelect optionsCfg.field / useRemoteOptions 语义一致。
 */
export function extractApiResponseList(
  response: unknown,
  field?: string | null,
): unknown[] {
  const root =
    response != null &&
    typeof response === 'object' &&
    !Array.isArray(response) &&
    (response as { data?: unknown }).data != null
      ? (response as { data: unknown }).data
      : response;

  if (field != null && field !== '') {
    if (root != null && typeof root === 'object' && !Array.isArray(root)) {
      const arr = (root as Record<string, unknown>)[field];
      return Array.isArray(arr) ? arr : [];
    }
    return [];
  }

  if (Array.isArray(root)) {
    return root;
  }

  if (root != null && typeof root === 'object') {
    const obj = root as { list?: unknown; records?: unknown };
    const arr = obj.list ?? obj.records;
    return Array.isArray(arr) ? arr : [];
  }

  return [];
}
